// components/templates/sections/GallerySection.tsx
'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useDesign } from '@/context/DesignContext';

interface GalleryItem {
  image: string;
  name: string;
  category: string;
  description: string;
  link?: string;
}

interface GallerySectionProps {
  items: GalleryItem[];
  design?: any;
}

export default function GallerySection({ items, design: propDesign }: GallerySectionProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const itemsArray = Array.isArray(items) ? items : [];
  const primaryColor = design?.colors?.primary || '#E07A5F';
  const bodyFont = design?.typography?.bodyFont || "'Plus Jakarta Sans', sans-serif";
  const headingFont = design?.typography?.headingFont || "'Sora', sans-serif";
  const borderRadius = design?.effects?.borderRadius || '8px';

  if (itemsArray.length === 0) {
    return (
      <section className="gallery">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <p className="text-center">Aucune image dans la galerie.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="gallery">
      <div className="container-fluid">
        <div className="row">
          <div className="gallery-main">
            {itemsArray.map((item, idx) => (
              <div className="gallery-box" key={idx}>
                <div className="image">
                  <Image 
                    src={item.image} 
                    alt={item.name} 
                    width={400} 
                    height={300} 
                    style={{ borderRadius }}
                  />
                </div>
                <div className="content">
                  <h5 className="name" style={{ fontFamily: headingFont }}>{item.name}</h5>
                  <p className="cate" style={{ fontFamily: bodyFont }}>{item.category}</p>
                  <div className="line" style={{ backgroundColor: primaryColor, height: '2px', width: '50px' }}></div>
                  <p className="text" style={{ fontFamily: bodyFont }}>{item.description}</p>
                  <Link href={item.link || '#'} className="action" style={{ color: primaryColor, textDecoration: 'none' }}>
                    <i className="fa fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}